import { observer } from 'mobx-react-lite'
import React from 'react'
import {
  Box,
  Button,
  ContainerHeader,
  Divider,
  EditableTitle,
  Icon,
  IconButton,
  variantActionsProps,
} from 'shared/ui'
import { REVIEW_NAME_LIMIT } from 'shared/constants/limits'
import { uiStore } from 'shared/store/uiStore'
import { mobilePreviewModal } from 'widgets/MobilePreview'
import { Preview } from 'pages/reviews/ui/Preview/Preview'
import { useReviewsPageContext, useReviewViewContext } from 'pages/reviews/context'
import styles from './styles.module.scss'

export const ReviewViewContentHeader = observer(() => {
  const {
    isLoading,
    isSaving,
    isEditMode,
    isUpdateDisabled,
    nameInputStore,
    errorsMap,
    removeError,
    handleSaveReview,
    returnTo,
  } = useReviewViewContext()
  const { focusOnMount, name, setName } = nameInputStore
  const { pageLayoutStore } = useReviewsPageContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore

  return (
    <ContainerHeader
      style={{ height: '100%', minHeight: 'unset', padding: '0 20px' }}
      titleVariant='heading-md'
      titleIconProps={titleIconProps}
      actionIconTooltipProps={headerMenuTooltipIconProps}
      titleIconAction={headerMenuIconAction}
      isBorderBottom
      isTitleDivider
      customTitle={
        <Box display={'flex'} alignItems={'center'}>
          <Icon
            icon={'starFilled1'}
            color={'var(--content-brand-primary)'}
            fontSize={20}
            padding='0 8px 0 6px'
          />
          <EditableTitle
            value={name}
            onChange={(value) => {
              removeError('name')
              setName(value)
            }}
            error={errorsMap.get('name')}
            limit={REVIEW_NAME_LIMIT}
            isAutoFocus={focusOnMount}
          />
        </Box>
      }
      actionsProps={{
        actions: [
          {
            buttonComponent: (
              <>
                <IconButton
                  ariaLabel='close_setting'
                  icon='close'
                  variant='contained'
                  color='secondary'
                  size='medium'
                  onClick={() =>
                    uiStore.changeRouteViaVue({
                      path: returnTo,
                    })
                  }
                />
                <Divider
                  orientation='vertical'
                  sx={{
                    height: '16px !important',
                    marginInline: '3.5px',
                    borderColor: 'var(--border-neutral-default)',
                  }}
                />
              </>
            ),
          },
          {
            buttonComponent: (
              <>
                <Button
                  contained={'primary'}
                  text={isEditMode ? 'Save changes' : 'Create'}
                  onClick={handleSaveReview}
                  loading={isLoading || isSaving}
                  disabled={isUpdateDisabled}
                />
                <Button
                  contained={'secondary'}
                  text='Preview'
                  className={styles.previewBtn}
                  onClick={() => {
                    mobilePreviewModal(<Preview isModal />, 434)
                  }}
                />
              </>
            ),
          },
        ],
        ...variantActionsProps.headerMedium,
        reverse: true,
      }}
    />
  )
})
